export type SignOutput = {
  data: String;
  encoding: {};
};
